<label class="field-label"><%= I18n.visit.visit_type.label %></label>
<div class="field-input select">
  <select data-appointment-booking-wizard-behaviour="field-input" data-field-input-type="integer" name="visit_type_id" role="listbox" tabindex="0">
    <% visit_types.forEach(function(visit_type) { %>
      <% if (returning_patient ? visit_type.valid_for_returning_patient : visit_type.valid_for_new_patient) { %>
        <option value="<%= visit_type.id %>" <% if (visit_type.id == visit_type_id) { %>selected<% } %> role="option" tabindex="0"><%- visit_type.name %></option>
      <% } %>
    <% }) %>
  </select>
</div>
<div class="field-action">
  <a class="caret" data-appointment-booking-wizard-behaviour="show-visit-type-help" role="button" tabindex="0"><%= I18n.visit.visit_type.comment %></a>
</div>
<div class="visit-type-callout-container"></div>
